module.exports = __webpack_public_path__ + "assets/img/thumb-McGrath-Social-Ad-Video.2e108c32.jpg";